"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderCard = exports.ProviderCardList = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const MiniProviderCard_1 = require("../MiniProviderCard");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ProviderCardList = styled_1.default.div `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  flex-wrap: wrap;
`;
exports.ProviderCard = (0, styled_1.default)(MiniProviderCard_1.MiniProviderCard) `
  min-width: 250px;
  display: grid;
`;
//# sourceMappingURL=MiniProviderCardList.styles.js.map